import {
  View,
  StyleSheet,
  TextInputProps,
  Pressable,
  Platform,
  TextInput,
} from "react-native";
import { ImageMapper } from "src/common/assets/images";
import Button from "./button";
import Text from "./text";
import { Image } from "src/common/components/image";
import { useEffect, useRef } from "react";

type SearchBarProps = {
  containerStyle?: object;
  style?: object;
  onPress?: () => void;
  onClear?: () => void;
  content?: string;
} & TextInputProps;

const SearchBar = ({
  containerStyle,
  style,
  onChangeText,
  onPress,
  onClear,
  ...props
}: SearchBarProps & TextInputProps) => {
  const RootView = onPress ? Pressable : View;
  const ref = useRef(null);
  const newProps = { ...props, autoFocus: false };

  useEffect(() => {
    if (props.autoFocus) {
      setTimeout(() => {
        ref?.current?.focus();
      }, 200);
    }
  }, [props.autoFocus]);

  return (
    <RootView style={[styles.container, style]} onPress={onPress}>
      <View style={[styles.root, containerStyle]}>
        <TextInput
          ref={ref}
          value=""
          style={[styles.title, { pointerEvents: onPress ? "none" : "auto" }]}
          numberOfLines={1}
          onChangeText={onChangeText}
          readOnly={!(!onPress && true)}
          {...newProps}
        />
        {!props.value?.length ? (
          <Image source={ImageMapper.Search} style={styles.searchIcon} />
        ) : (
          <Button solid={false} onPress={onClear}>
            <Text style={[styles.headerName]}>✕</Text>
          </Button>
        )}
      </View>
    </RootView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
  },
  root: {
    height: 50,
    borderWidth: 1,
    borderColor: "#636E72",
    borderRadius: 15,
    marginHorizontal: 20,
    alignItems: "center",
    paddingHorizontal: 20,
    flexDirection: "row",
  },
  title: {
    fontFamily: "Montserrat",
    fontWeight: "400",
    lineHeight: 20,
    ...(Platform.OS === "web" && { outlineStyle: "none" }),
    color: "#636E72",
    fontSize: 16,
    flex: 1,
    marginRight: 20,
    height: 40,
    ...Platform.select({
      web: {
        outlineWidth: 0,
      },
    }),
  },
  headerName: {
    color: "#636E72",
    fontSize: 20,
    fontFamily: "MontserratBold",
  },
  searchIcon: {
    height: 24,
    width: 24,
  },
});

export default SearchBar;
